export function autocompleteChangeCallback({ dispatch, fetchAction, minLength = 3 }) {
  return function (updatedValue) {
    updatedValue.length >= minLength && dispatch(fetchAction(updatedValue))
  }
}
